import React, { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';


import HtlWarehSubEdit from "./HtlWarehSubEdit";
import HtlResRoomGuestEdit from "./HtlResRoomGuestEdit"
import HtlResRoomFolioDtl from "./HtlResRoomFolioDtl";
//import HtlAgnOffChart from "./HtlAgnOffChart";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputSwitch } from "primereact/inputswitch";
import { Divider } from 'primereact/divider';






const GET_POST = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
  

    ) {
        tbl_rez_rooms(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
          
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       folio_id
       room_class
       room_type
       arrival_date
       departure_date
       person_adl
       person_chl
       guar_use
    

  } 
  
}
`;

const GET_REZ_ACC_PRE_FOL = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
  

    ) {
      tbl_rez_room_dtl(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
          
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       room_dtl_id
       get_room_folio_price_calc(where: {        
        red_sup: { _eq: "R" } 
      }) {
        code
        value
        type
      }
       date
       room_code
       product_code
       type
       quantity
       unit
       price
       price_base
       currency
       date
       debit
       credit
       firm_main_code
       firm_sub_code

      
    

  } 
  
}
`;

const GET_REZ_ACC_PRE_FOL_CALC = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
  

    ) {
      tbl_rez_room_dll_calc(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
          
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       rez_room_dtl_id
       code
       value
       red_sup
       priority
       type

      
    

  } 
  
}
`;

const GET_AVA = gql`
query MyQuery(
  $resMidId: Int,
  $resRoomId: Int,
  $ownFirmCode: String,
  $ownFirmSubCode: String,
  $resRoomType: String,
  $startDate: date,
  $endDate: date
) {
  tbl_htl_room_type_ava_sts(
    order_by: { date: asc },
    where: {
      room_type: { _eq: $resRoomType },
      firm_main_code: { _eq: $ownFirmCode },
      firm_sub_code: { _eq: $ownFirmSubCode },
      date: { _gte: $startDate, _lte: $endDate }
    }
  ) {
    room_class
    room_type
    date
    capacity
    close
    booking
    guaranty
    pseudo
    waiting
  }
}
`;

const GET_AVA_CONT = gql`
  query MyQuery(
    $resMidId: Int,
    $resRoomId: Int,
    $ownFirmCode: String,
    $ownFirmSubCode: String,
    $resRoomType: String,
    $startDate: date,
    $endDate: date
  ) {
    tbl_htl_room_type_ava_dtl_sts(
      order_by: { date: asc },
      where: {
        room_type: { _eq: $resRoomType },
        firm_main_code: { _eq: $ownFirmCode },
        firm_sub_code: { _eq: $ownFirmSubCode },
        _and: [
          { date: { _gte: $startDate } },
          { date: { _lte: $endDate } }
        ]
      }
    ) {
      room_class
      room_type
      date
      room_total_contg
      room_contg_use
      room_total_gua
      room_gua_use
      quata_use
      change_contg
      pseudo
    }
  }
`;

const GET_GUEST_LIST = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
  
  

    ) {
      tbl_rez_guest_mid_list(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
          
       
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       guest_id
       profile_id
       title
       name
       last_name
       age
       country
       guest_type

       
    

  } 
  
}
`;

const UPDATE_ROOM = gql`
mutation UpdateRoom(
    $resMidId: Int
    $resRoomId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $resFolioId: Int
    $resRoomClass: String
    $resRoomType: String
    $startDate: date
    $endDate: date
    $perAdl: Int
    $perChl: Int
    $totalPerPriceText: float8
    $guaUse: Boolean
   
    
  ) {
    update_tbl_rez_rooms(
      where: {
        rez_mid_id: {_eq: $resMidId}
        rez_room_id: {_eq: $resRoomId}          
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        room_class: $resRoomClass
        room_type: $resRoomType
        arrival_date: $startDate
        departure_date: $endDate
        person_adl: $perAdl
        person_chl: $perChl
        room_sub_total: $totalPerPriceText
        guar_use: $guaUse
       
      }
    ) {
      affected_rows
    }
  }
`; 




const INSERT_ROOM = gql`
  mutation InsertRoom(
    $resTopId: Int
    $resMidId: Int
    $resRoomId: Int
    $resFolioId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
   
    $resRoomClass: String
    $resRoomType: String
    $startDate: date
    $endDate: date
    $perAdl: Int
    $perChl: Int
    $guaUse: Boolean
   

   
    
  ) {
    insert_tbl_rez_rooms(
      objects: {
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        rez_top_id: $resTopId,
        rez_mid_id: $resMidId,
        rez_room_id: $resRoomId,
        folio_id: $resFolioId,
        room_class: $resRoomClass,
        room_type: $resRoomType,
        arrival_date: $startDate,
        departure_date: $endDate,
        person_adl: $perAdl,
        person_chl: $perChl,
        guar_use: $guaUse
      

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_ROOM_TYPE = gql`
query GetHtlRoomsTyp(
    $ownFirmCode: String
    $ownFirmSubCode: String
    $perAdl: Int
  ) {
    tbl_htl_room_type(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
        _and: [
          { max_adl: { _gte: $perAdl } },
          { min_adl: { _lte: $perAdl } }
        ]
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_type_code
      r_type_name
      min_adl
      max_adl
      min_chl
      max_chl
      active
    }
  }
`;

const GET_ROOM_CLASS = gql`
query GetHtlRoomsCls(
    $ownFirmCode: String
    $ownFirmSubCode: String
   
  ) {
    tbl_htl_room_class(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_class_name
      active
    }
  }
`;


const GET_RULES_TYP = gql`
  query MyQuery( $lang: String, $defType: String, $ruleClass: String) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const UPDATE_RULES = gql`
mutation UpdateRules(
    $dprMainCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $active: Boolean
   
    
  ) {
    update_tbl_dpr_main(
      where: {
        dpr_main_code: { _eq: $dprMainCode }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        dpr_dpr_type: $ruleType
        dpr_main_name: $rulesName
        active: $active
       
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_CONTRACT_PRICES = gql`
  query GetContractPrices($ownFirmCode: String, $contId: Int, $resRoomType: String, $perAdl: Int, $perChl: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $ownFirmCode }
      cont_id: { _eq: $contId }
    }) {
      start_date
      end_date
      period
      cont_id      
      get_per_price_chl(where: { 
        child: { _gte: 1, _lte: $perChl }
        r_type_code: { _eq: $resRoomType } 
      }) {
        cont_id        
        period        
        per_price
        currency
        adult
      }
      get_per_price(where: { 
        adult: { _eq: $perAdl }
        r_type_code: { _eq: $resRoomType }
      }) {
        cont_id        
        period        
        per_price
        currency
        adult
        get_room_tax(where: { 
          opr_filter: { _eq: "VAT" }
          source_code: { _eq: "ACC" }
        }) {
          source_code
          opr_filter_gnl
          card_value
      } }
      get_cont_rule_id(where: { 
        cont_id: { _eq: $contId }
      }) {
        cont_id
        get_cont_rule_sub_grp(where: { 
          rules_sub_type: { _eq: "GRPO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "PER" }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "REDP" }
            }) {
              act_type
              int_var_1                     
            }
          }
        }
        get_cont_rule_sub_lst(where: { 
          rules_sub_type: { _eq: "LSO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "REDP" }
            }) {
              act_type
              int_var_1
            }
          }
        }
        get_cont_rule_sub_sen(where: { 
          rules_sub_type: { _eq: "SSO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "AGE" }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "REDP" }
            }) {
              act_type
              int_var_1
            }
          }
        }
        get_cont_rule_sub_hmo(where: { 
          rules_sub_type: { _eq: "HMO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "REDP" }
            }) {
              act_type
              int_var_1
            }
          }
        }
        get_cont_rule_sub_ebo_pay(where: { 
          rules_sub_type: { _eq: "EBO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
            int_var_1: { _eq: 0 }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "PAYP" }
              pre_type: { _eq: "RESDA" }
              
            }) {
              act_type
              int_var_1
            }
          }
        }
        

        get_cont_rule_sub_ebo_pay_static(where: { 
          rules_sub_type: { _eq: "EBO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
            int_var_1: { _eq: 0 }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "PAYP" }
              pre_type: { _eq: "DATE" }
              
            }) {
              act_type
              int_var_1
            }
          }
        }
        get_cont_rule_sub_ebo_pay_checkin(where: { 
          rules_sub_type: { _eq: "EBO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
            int_var_1: { _eq: 0 }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "PAYP" }
              pre_type: { _eq: "CHCIN" }
              
            }) {
              act_type
              int_var_1
            }
          }
        }

        
        get_cont_rule_sub_ebo(where: { 
          rules_sub_type: { _eq: "EBO" }
        }) {
          id_seq
          r_prn_id_seq        
          rules_sub_type   
          get_cont_rule_grp(where: { 
            pre_type: { _eq: "STY" }
          }) {
            pre_type
            r_prn_id_seq
            get_cont_rule_act(where: { 
              act_type: { _eq: "REDP" }
            }) {
              act_type
              int_var_1
            }
          }
        }
      }
    }
  }
`;






const GET_CONTRACT_PRICES_x = gql`
  query GetContractPrices($ownFirmCode: String, $contId: Int, $resRoomType: String, $perAdl: Int, $perChl: Int) {
    tbl_cont_per_def(
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        cont_id: { _eq: $contId }
      }
    ) {     
      cont_id
      get_per_price_chl(
        where: {
          child: { _gte: 1, _lte: $perChl },
          r_type_code: { _eq: $resRoomType },
          _and: [
            { price_date: { _gte: $startDate } },
            { price_date: { _lte: $endDate } }
          ]
        }
      ) {
        cont_id
        period
        per_price
        currency
        adult
        price_date
      }
      
      get_per_price(
        where: {
          adult: { _eq: $perAdl }
          r_type_code: { _eq: $resRoomType }
          
        }
      ) {
        cont_id
        period
        per_price
        currency
        adult
        price_date
      }
    }
  }
`;


const GET_CONTRACT_PRICES_MURAT = gql`
  query MyQuery($contId: Int, $ownFirmCode: String, $startDate: date, $endDate: date, $perAdl: Int, $perChl: Int, $resRoomType: String ) {
    tbl_cont_per_price(
      order_by: { price_date: asc },
      where: {
        cont_id: { _eq: $contId },
        firm_main_code: { _eq: $ownFirmCode },
        adult: { _eq: $perAdl },
        r_type_code: { _eq: $resRoomType },
        _and: [
          { price_date: { _gte: $startDate } },
          { price_date: { _lte: $endDate } }
        ]
      }
    ) {
      cont_id
      price_date
      adult
      child
      per_price
      get_child_daily_price(where: { 
        child: { _gte: 1, _lte: $perChl }
      }) {
        cont_id        
        period        
        per_price
        currency
        child
      }
      get_room_tax(where: { 
        opr_filter: { _eq: "VAT" }
        source_code: { _eq: "ACC" }
      }) {
        source_code
        opr_filter_gnl
        card_value
      }
    }
  }
`;

const GET_CONTRACT_PRICES_xx = gql`
  query GetContractPrices($ownFirmCode: String, $contId: Int, $resRoomType: String, $perAdl: Int, $perChl: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $ownFirmCode }
      cont_id: { _eq: $contId }
    }) {
      start_date
      end_date
      period
      cont_id      
        get_per_price_chl(where: {          
          child: { _gte: 1, _lte: $perChl }
          r_type_code: { _eq: $resRoomType } 
        }) {
        cont_id        
        period        
        per_price
        currency
        adult
     
      }
      get_per_price(where: { 
        adult: { _eq: $perAdl }
        r_type_code: { _eq: $resRoomType }
      }) {
        cont_id        
        period        
        per_price
        currency
        adult
      }
    }
  }
`;

const INSERT_REZ_ROOM_DTL = gql`
  mutation InsertRezRoomDtl($objects: [tbl_rez_room_dtl_insert_input!]!) {
    insert_tbl_rez_room_dtl(objects: $objects) {
      returning {
        room_dtl_id
      }
    }
  }
`;

const INSERT_REZ_ROOM_DLL_CALC = gql`
  mutation InsertRezRoomDllCalc($objects: [tbl_rez_room_dll_calc_insert_input!]!) {
    insert_tbl_rez_room_dll_calc(objects: $objects) {
      returning {
        rez_room_dtl_id
      }
    }
  }
`;

const UPDATE_REZ_ROOM_DTL_PRICE = gql`
  mutation UpdateRezRoomDtlPrice($rezTopId: Int!, $rezMidId: Int!,$rezRoomId: Int!,  $id: Int!, $price: float8!,  $credit: float8!, $ownFirmCode: String!, $ownFirmSubCode: String!) {
    update_tbl_rez_room_dtl_by_pk(
      pk_columns: { room_dtl_id: $id, rez_top_id: $rezTopId, rez_mid_id: $rezMidId,  rez_room_id: $rezRoomId, firm_main_code: $ownFirmCode, firm_sub_code: $ownFirmSubCode }
      _set: { price: $price, credit: $credit }
    ) {
      room_dtl_id
      price
      price_base
      credit
    }
  }
`;

const DELETE_REZ_FOLIO = gql`
mutation DeleteRezFolio(
  $resMidId: Int
  $resRoomId: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_rez_room_dtl(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      rez_mid_id: { _eq: $resMidId }
      rez_room_id: { _eq: $resRoomId }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_REZ_ROOM = gql`
mutation DeleteRezRoom(
  $resMidId: Int
  $resRoomId: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_rez_rooms(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      rez_mid_id: { _eq: $resMidId }      
      rez_room_id: { _eq: $resRoomId }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_REZ_GUEST = gql`
mutation DeleteRezGuest(
  $resMidId: Int
  $resRoomId: Int
 
) {
  delete_tbl_rez_guest_mid_list(
    where: {
      
      rez_mid_id: { _eq: $resMidId }      
      rez_room_id: { _eq: $resRoomId }
    }
  ) {
    affected_rows
  }
}
`;

const DELETE_REZ_FOLIO_CALC = gql`
mutation DeleteRezFolioCalc(
  $resMidId: Int
  $resRoomId: Int
  $firmMainCode: String
  $firmSubCode: String
) {
  delete_tbl_rez_room_dll_calc(
    where: {
      firm_main_code: { _eq: $firmMainCode }
      firm_sub_code: { _eq: $firmSubCode }
      rez_mid_id: { _eq: $resMidId }
      rez_room_id: { _eq: $resRoomId }
    }
  ) {
    affected_rows
  }
}
`;

const UPDATE_BOOKING_COUNT = gql`
  mutation UpdateBookingCount($date: date!, $room_code: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_code },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { booking: 1 }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BOOKING_COUNT_DOWN = gql`
  mutation UpdateBookingCount($date: date!, $room_code: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_code },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { booking: -1 }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BOOKING_GUAT = gql`
  mutation UpdateBookingCount($date: date!, $room_type: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_dtl_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_type },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { room_contg_use: 1 }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BOOKING_GUAT_DOWN = gql`
  mutation UpdateBookingCount($date: date!, $room_type: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_dtl_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_type },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { room_contg_use: -1 }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BOOKING_GUAR = gql`
  mutation UpdateBookingCount($date: date!, $room_type: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_dtl_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_type },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { room_gua_use: 1 }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_BOOKING_GUAR_DOWN = gql`
  mutation UpdateBookingCount($date: date!, $room_type: String!, $firm_main_code: String!, $firm_sub_code: String!) {
    update_tbl_htl_room_type_ava_dtl_sts(
      where: {
        date: { _eq: $date },
        room_type: { _eq: $room_type },
        firm_main_code: { _eq: $firm_main_code },
        firm_sub_code: { _eq: $firm_sub_code }
      },
      _inc: { room_gua_use: -1 }
    ) {
      affected_rows
    }
  }
`;







const HtlResRoomAdd = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode4, setVarCode4} = useContext(ThemeContext);
   const {varCode3, setVarCode3} = useContext(ThemeContext);
   const {varCode7, setVarCode7} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode14, setVarCode14} = useContext(ThemeContext);
   const {varCode15, setVarCode15} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  
  
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;
  

  const lang = users.userLang;




 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { resMidId: varCode4, resRoomId: varCode8, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode   },
  });





  const firmData = data && data.tbl_rez_rooms ? data.tbl_rez_rooms[0] : null;
  
 

  const [updateRulesPrn] = useMutation(UPDATE_ROOM);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_ROOM);

  const [displayBasic2, setDisplayBasic2] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
 // const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
 // const [seaDesc, setSeaDesc] = useState(firmData ? firmData.firm_sub_code_k : ""); 
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.rez_mid_id : ""); 
  const [firmTrg, setFirmTrg] = useState(""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.dpr_main_name : ""); 
 // const [ruleClass, setRulesClass] = useState(firmData ? firmData.build_plan_type : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.dpr_dpr_type : ""); 
  const [active, setActive] = useState(firmData ? firmData.active : ""); 
  const [ruleClass2, setRulesClas2] = useState(); 

  const [resMidId, setResMidId] = useState(firmData ? firmData.rez_mid_id : varCode4); 
  const [resRoomId, setResRoomId] = useState(firmData ? firmData.rez_room_id : ""); 
  const [resTopId, setResTopId] = useState(firmData ? firmData.rez_top_id : varCode7); 
  const [resFolioId, setResFolioId] = useState(firmData ? firmData.folio_id : ""); 
  const [resRoomClass, setResRoomClass] = useState(firmData ? firmData.room_class : ""); 
  const [resRoomType, setResRoomType] = useState(firmData ? firmData.room_type : ""); 
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.arrival_date): (new Date(varCode9)));
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.departure_date) : (new Date(varCode10)));
  const [perAdl, setPerAdl] = useState(firmData ? firmData.person_adl : 0); 
  const [perChl, setPerChl] = useState(firmData ? firmData.person_chl : 0); 
  const [guaUse, setGuaUse] = useState(firmData ? firmData.guar_use : false); 


  
 // const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
 // const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(0);


  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
 
  const new_rule_grp_btn = messages[currentLocale].new_rule_grp_btn;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_desc_title = messages[currentLocale].rule_desc_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const rule_type_name_title = messages[currentLocale].rule_type_name_title;
  const select_rule_class_hint = messages[currentLocale].select_rule_class_hint;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
 

  

  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_ROOM_CLASS, {
    variables: { ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode},
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_ROOM_TYPE, {
    variables: {perAdl: perAdl,  ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode},
  });

  const localStartDate = new Date(startDate);
  const localEndDate = new Date(endDate);


    const { loading: loodingava, error: errorava, data: dataava, refetch: refechava } = useQuery(GET_AVA, {
    variables: { resRoomType:resRoomType, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, 
      
      startDate: localStartDate.toLocaleDateString(),
      endDate: localEndDate.toLocaleDateString(), },
  });

  //const firmData2 = dataava && dataava.tbl_htl_room_type_ava_sts ? dataava.tbl_htl_room_type_ava_sts[0] : null;
  const firmData2 = dataava && dataava.tbl_htl_room_type_ava_sts;

  const { loading: loodingavacont, error: erroravacont, data: dataavacont, refetch: refechavacont } = useQuery(GET_AVA_CONT, {
    variables: { resRoomType:resRoomType, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, 
      
      startDate: localStartDate.toLocaleDateString(),
      endDate: localEndDate.toLocaleDateString(), },
  });



  //const firmData2 = dataava && dataava.tbl_htl_room_type_ava_sts ? dataava.tbl_htl_room_type_ava_sts[0] : null;
  const firmData3 = dataavacont && dataavacont.tbl_htl_room_type_ava_dtl_sts;

  const { loading: loodinggue, error:errorgue, data: datague, refetch: refechgue } = useQuery(GET_GUEST_LIST, {
    variables: { resMidId: resMidId, resRoomId: resRoomId },
  });

  const firmData5 = datague && datague.tbl_rez_guest_mid_list;

  const { loading: loodinpreaccfol, error:errorpreaccfol, data: datapreaccfol, refetch: refechpreaccfol } = useQuery(GET_REZ_ACC_PRE_FOL, {
    variables: { resMidId: resMidId, resRoomId: resRoomId, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode },
  });

  const firmData6 = datapreaccfol && datapreaccfol.tbl_rez_room_dtl;


  const dates = [];

  const { loading:pricelooding, error:errorprice, data:dataprice } = useQuery(GET_CONTRACT_PRICES, {
    variables: { ownFirmCode: ownFirmCode, contId: varCode15, resRoomType: resRoomType, perAdl: perAdl, perChl: perChl },
  });

  const firmData4 = dataprice && dataprice.tbl_cont_per_def;



  const { loading: loodingprc, error: errorprc, data: dataaprc, refetch: refechprc } = useQuery(GET_CONTRACT_PRICES_MURAT, {
    variables: {
      contId: varCode15,
      ownFirmCode: ownFirmCode,
      perAdl: perAdl,
      perChl: perChl,
      resRoomType: resRoomType,
      startDate: localStartDate.toLocaleDateString(),
      endDate: localEndDate.toLocaleDateString(),
    },
  });

  const firmData41 = dataaprc ? dataaprc.tbl_cont_per_price : [];


  const totalAdultPrice = firmData41.reduce((sum, row) => sum + row.per_price, 0);
  const totalChildPrice = firmData41.reduce((sum, row) => sum + row.get_child_daily_price.reduce((childSum, child) => childSum + child.per_price, 0), 0);
  const totalPrice = totalAdultPrice + totalChildPrice;



  const handleInsert2 = async () => {
    const rows = [];
    const taxRows2 = [];
  
    if (firmData41) {
      for (const contract of firmData41) {
        const contractStartDate = new Date(contract.start_date);
        const contractEndDate = new Date(contract.end_date);
        const formattedDate = new Date(contract.price_date);
  
        const totalPerPriceForDay = contract.per_price;
        const totalChlPriceForDay = contract.get_child_daily_price
          ? contract.get_child_daily_price.reduce((total, price) => total + price.per_price, 0)
          : 0;
  
        if (totalPerPriceForDay === 0 && totalChlPriceForDay === 0) {
          continue;
        }
  
        const idSeq = await handleUpdateIdSeq3();
  
        // Vergi hesaplaması
        let totalPrice = totalPerPriceForDay + totalChlPriceForDay;
        let totalTax = 0;
        if (contract.get_room_tax) {
          contract.get_room_tax.forEach(tax => {
       //     const taxAmount = (totalPrice * tax.card_value) / 100;
            const taxAmount = totalPrice * (tax.card_value / (100 + tax.card_value));
            totalPrice -= taxAmount;
            totalTax += taxAmount;
  
            // Vergi satırlarını oluşturma
            taxRows2.push({
              firm_main_code: ownFirmCode,
              firm_sub_code: ownFirmSubCode,
              rez_mid_id: resMidId,
              rez_room_id: resRoomId,
              rez_room_dtl_id: idSeq,
              code: 'TAX',
              value: tax.card_value,
              red_sup: 'R',
              priority: 1,
              type: 'TAX',
            });
          });
        }
  
        // Veri ekleme
        rows.push({
          firm_main_code: ownFirmCode,
          firm_sub_code: ownFirmSubCode,
          rez_top_id: resTopId,
          rez_mid_id: resMidId,
          rez_room_id: resRoomId,
          room_dtl_id: idSeq,
          date: formattedDate,
          room_code: resRoomType,
          product_code: 'ACC',
          type: 'ACC',
          quantity: 1,
          unit: 'NGT',
          price: totalPerPriceForDay + totalChlPriceForDay,
          price_base: totalPerPriceForDay + totalChlPriceForDay,
          currency: contract.get_child_daily_price.length > 0 ? contract.get_child_daily_price[0].currency : "N/A",
          debit: 0,
          credit: totalPerPriceForDay + totalChlPriceForDay,
        });
      }
    }
  
    if (rows.length > 0) {
      try {
        await insertRezRoomDtl({ variables: { objects: rows } });
        console.log('Kayıtlar başarıyla eklendi.');
  
        if (taxRows2.length > 0) {
          await insertRezRoomDllCalc({ variables: { objects: taxRows2 } });
          console.log('Vergi kayıtları başarıyla eklendi.');
         
        }
  
        refechpreaccfol();
      } catch (error) {
        console.error('Ekleme hatası:', error);
        console.error('Hata detayları:', JSON.stringify(error, null, 2));
      }
    }
  };





  useEffect(() => {
    if (dataaprc) {
      console.log("log",dataaprc);
      
    }
  }, [dataaprc]);

  useEffect(() => {
    if (dataaprc) {
      console.log("Fetched data:", dataaprc);
    }
  }, [dataaprc]);

  // Check for loading and error states
  if (loodingprc) {
    console.log("Loading data...");
  }

  if (errorprc) {
    console.error("Error fetching data:", errorprc);
  }




const arrivalDate = new Date(startDate);
const departureDate = new Date(endDate);


let totalPerPrice = 0;
let totalAdlPrice = 0;
let totalChlPrice = 0;
let totalDiscount = 0;
let totalPaymentAmount = 0;
let totalPaymentAmount2 = 0;
let totalPaymentAmount3 = 0;

// İndirim kurallarının uygulanma sırasını belirleyen yapı
const discountOrder = ["EBO", "GRPO", "SSO", "LSO", "HMO"]; // Öncelik sırasına göre indirim tiplerini belirleyin

const applyDiscounts = (totalPrice, discountRules, discountOrder) => {
  let discountTotal = 0;
  discountOrder.forEach(order => {
    const rule = discountRules.find(r => r.type === order);
    if (rule) {
      const discountFactor = (100 - rule.intVar) / 100;
      const priceBeforeDiscount = totalPrice;
      totalPrice *= discountFactor;
      discountTotal += priceBeforeDiscount * (1 - discountFactor);
    }
  });
  return { totalPrice, discountTotal };
};

// Vergi kurallarını uygulayan fonksiyon
const removeTaxes = (totalPrice, taxRules) => {
  let taxTotal = 0;
  taxRules.forEach(tax => {
    const taxAmount = totalPrice * (tax.card_value / (100 + tax.card_value));
    taxTotal += taxAmount;
  });
  return { totalPrice: totalPrice - taxTotal, taxTotal };
};

// Vergileri geri ekleyen fonksiyon
const addTaxes = (totalPrice, taxRules) => {
  let taxTotal = 0;
  taxRules.forEach(tax => {
    const taxAmount = totalPrice * (tax.card_value / 100);
    taxTotal += taxAmount;
  });
  return { totalPrice: totalPrice + taxTotal, taxTotal };
};

const rows = [];
if (firmData4) {
  firmData4.forEach(contract => {
    const startDate = new Date(contract.start_date);
    const endDate = new Date(contract.end_date);

    for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
      const formattedDate = date.toLocaleDateString('en-GB');

      if (date >= arrivalDate && date <= departureDate) {
        const currencies = contract.get_per_price ? contract.get_per_price.map(price => price.currency).join(', ') : "N/A";
        const perPrices = contract.get_per_price ? contract.get_per_price.map(price => price.per_price).join(', ') : "N/A";
        const chlPrices = contract.get_per_price_chl ? contract.get_per_price_chl.map(price => price.per_price).join(', ') : "N/A";

        const totalPerPriceForDay = contract.get_per_price ? contract.get_per_price.reduce((total, price) => total + price.per_price, 0) : 0;
        const totalChlPriceForDay = contract.get_per_price_chl ? contract.get_per_price_chl.reduce((total, price) => total + price.per_price, 0) : 0;

        if (totalPerPriceForDay === 0 && totalChlPriceForDay === 0) {
          rows.push({
            date: formattedDate,
            period: contract.period,
            currency: currencies,
            per_price: perPrices,
            chl_price: chlPrices,
            total_price: '0.00',
            total_price_ndisc: '0.00',
            payment_amount: '0.00',
            payment_amount2: '0.00',
            payment_amount3: '0.00'
          });
          continue;
        }

        // İndirim kurallarını sırayla uygulamak için dizi
        const discountRules = [];

        // GRPO indirimi
        const intVar1GRPO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_grp[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1GRPO) {
          discountRules.push({ type: 'GRPO', intVar: intVar1GRPO });
        }

        // SSO indirimi
        const intVar1SSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_sen[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1SSO) {
          discountRules.push({ type: 'SSO', intVar: intVar1SSO });
        }

        // EBO indirimi
        const intVar1EBO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1EBO) {
          discountRules.push({ type: 'EBO', intVar: intVar1EBO });
        }

        // HMO indirimi
        const intVar1HMO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_hmo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1HMO) {
          discountRules.push({ type: 'HMO', intVar: intVar1HMO });
        }

        // PAYR ödeme miktarı
        const intVar1PAY = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY) {
          discountRules.push({ type: 'PAYR', intVar: intVar1PAY });
        }

        // PAYR2 ödeme miktarı
        const intVar1PAY2 = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay_checkin[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY2) {
          discountRules.push({ type: 'PAYR2', intVar: intVar1PAY2 });
        }

        // PAYR3 ödeme miktarı
        const intVar1PAY3 = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay_static[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY3) {
          discountRules.push({ type: 'PAYR3', intVar: intVar1PAY3 });
        }

        // LSO indirimi
        const intVar1LSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_lst[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1LSO) {
          discountRules.push({ type: 'LSO', intVar: intVar1LSO });
        }

        // Vergi kurallarını uygula (önce vergi düşülecek)
        const taxRules = contract.get_per_price[0]?.get_room_tax || [];
        let totalPriceForDay = totalPerPriceForDay + totalChlPriceForDay;
        const { totalPrice: priceWithoutTaxes, taxTotal: totalTaxesRemoved } = removeTaxes(totalPriceForDay, taxRules);

        // İndirim kurallarını belirlenen sıraya göre uygula
        const { totalPrice: priceAfterDiscounts, discountTotal } = applyDiscounts(priceWithoutTaxes, discountRules, discountOrder);

        // Vergileri geri ekle (indirimlerden sonra)
        const { totalPrice: finalPriceWithTaxes, taxTotal: totalTaxesAdded } = addTaxes(priceAfterDiscounts, taxRules);

        // Toplamları güncelle
        totalDiscount += discountTotal;
        totalAdlPrice += totalPerPriceForDay;
        totalChlPrice += totalChlPriceForDay;

        // Ödeme miktarını hesapla
        let paymentAmountForDay = 0;
        let paymentAmountForDay2 = 0;
        let paymentAmountForDay3 = 0;

        const payrRule = discountRules.find(r => r.type === 'PAYR');
        if (payrRule) {
          paymentAmountForDay = priceAfterDiscounts * (payrRule.intVar / 100);
        }

        const payrRule2 = discountRules.find(r => r.type === 'PAYR2');
        if (payrRule2) {
          paymentAmountForDay2 = priceAfterDiscounts * (payrRule2.intVar / 100);
        }

        const payrRule3 = discountRules.find(r => r.type === 'PAYR3');
        if (payrRule3) {
          paymentAmountForDay3 = priceAfterDiscounts * (payrRule3.intVar / 100);
        }

        totalPaymentAmount += paymentAmountForDay;
        totalPaymentAmount2 += paymentAmountForDay2;
        totalPaymentAmount3 += paymentAmountForDay3;

        // Her bir gün için veri satırlarını ekle
        rows.push({
          date: formattedDate,
          period: contract.period,
          currency: currencies,
          per_price: perPrices,
          chl_price: chlPrices,
          total_price: finalPriceWithTaxes.toFixed(2),
          total_price_ndisc: totalPriceForDay.toFixed(2),
          payment_amount: paymentAmountForDay.toFixed(2),
          payment_amount2: paymentAmountForDay2.toFixed(2),
          payment_amount3: paymentAmountForDay3.toFixed(2),
          tax_removed: totalTaxesRemoved.toFixed(2),
          discount_applied: discountTotal.toFixed(2),
          tax_added: totalTaxesAdded.toFixed(2)
        });

        if (contract.get_per_price) {
          contract.get_per_price.forEach(price => {
            totalPerPrice += price.per_price;
          });
        }
      }
    }
  });
}

// Genel toplamları hesapla
const totalPerPriceText = (totalAdlPrice + totalChlPrice).toFixed(2);
const totalDiscountText = totalDiscount.toFixed(2);
const totalPriceWithDiscountText = (totalAdlPrice + totalChlPrice - totalDiscount).toFixed(2);
const totalPaymentAmountText = totalPaymentAmount.toFixed(2);
const totalPaymentAmountText2 = totalPaymentAmount2.toFixed(2);
const totalPaymentAmountText3 = totalPaymentAmount3.toFixed(2);
const totalTaxRemovedText = rows.reduce((total, row) => total + parseFloat(row.tax_removed), 0).toFixed(2);
const totalTaxAddedText = rows.reduce((total, row) => total + parseFloat(row.tax_added), 0).toFixed(2);
const finalTotalPriceWithTaxes = rows.reduce((total, row) => total + parseFloat(row.total_price), 0).toFixed(2);

rows.push({
  date: "Total",
  period: "",
  currency: "EUR",
  per_price: totalPerPriceText,
  total_discount: totalDiscountText,
  total_price_with_discount: totalPriceWithDiscountText,
  payment_amount: totalPaymentAmountText,
  payment_amount2: totalPaymentAmountText2,
  payment_amount3: totalPaymentAmountText3,
  tax_removed: totalTaxRemovedText,
  tax_added: totalTaxAddedText,
  final_total_price_with_taxes: finalTotalPriceWithTaxes
});



//daily price

const rows2 = [];
if (firmData4) {
  firmData4.forEach(contract => {
    const startDate = new Date(contract.start_date);
    const endDate = new Date(contract.end_date);

    for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
      const formattedDate = date.toLocaleDateString('en-GB');

      if (date >= arrivalDate && date <= departureDate) {
        const currencies = contract.get_per_price ? contract.get_per_price.map(price => price.currency).join(', ') : "N/A";
        const perPrices = contract.get_per_price ? contract.get_per_price.map(price => price.per_price).join(', ') : "N/A";
        const chlPrices = contract.get_per_price_chl ? contract.get_per_price_chl.map(price => price.per_price).join(', ') : "N/A";

        const totalPerPriceForDay = contract.get_per_price ? contract.get_per_price.reduce((total, price) => total + price.per_price, 0) : 0;
        const totalChlPriceForDay = contract.get_per_price_chl ? contract.get_per_price_chl.reduce((total, price) => total + price.per_price, 0) : 0;

        if (totalPerPriceForDay === 0 && totalChlPriceForDay === 0) {
          rows.push({
            date: formattedDate,
            period: contract.period,
            currency: currencies,
            per_price: perPrices,
            chl_price: chlPrices,
            total_price: '0.00',
            total_price_ndisc: '0.00',
            payment_amount: '0.00',
            payment_amount2: '0.00',
            payment_amount3: '0.00'
          });
          continue;
        }

        // İndirim kurallarını sırayla uygulamak için dizi
        const discountRules = [];

        // GRPO indirimi
        const intVar1GRPO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_grp[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1GRPO) {
          discountRules.push({ type: 'GRPO', intVar: intVar1GRPO });
        }

        // SSO indirimi
        const intVar1SSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_sen[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1SSO) {
          discountRules.push({ type: 'SSO', intVar: intVar1SSO });
        }

        // EBO indirimi
        const intVar1EBO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1EBO) {
          discountRules.push({ type: 'EBO', intVar: intVar1EBO });
        }

        // HMO indirimi
        const intVar1HMO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_hmo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1HMO) {
          discountRules.push({ type: 'HMO', intVar: intVar1HMO });
        }

        // PAYR ödeme miktarı
        const intVar1PAY = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY) {
          discountRules.push({ type: 'PAYR', intVar: intVar1PAY });
        }

        // PAYR2 ödeme miktarı
        const intVar1PAY2 = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay_checkin[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY2) {
          discountRules.push({ type: 'PAYR2', intVar: intVar1PAY2 });
        }

        // PAYR3 ödeme miktarı
        const intVar1PAY3 = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo_pay_static[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1PAY3) {
          discountRules.push({ type: 'PAYR3', intVar: intVar1PAY3 });
        }

        // LSO indirimi
        const intVar1LSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_lst[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
        if (intVar1LSO) {
          discountRules.push({ type: 'LSO', intVar: intVar1LSO });
        }

        // Vergi kurallarını uygula (önce vergi düşülecek)
        const taxRules = contract.get_per_price[0]?.get_room_tax || [];
        let totalPriceForDay = totalPerPriceForDay + totalChlPriceForDay;
        const { totalPrice: priceWithoutTaxes, taxTotal: totalTaxesRemoved } = removeTaxes(totalPriceForDay, taxRules);

        // İndirim kurallarını belirlenen sıraya göre uygula
        const { totalPrice: priceAfterDiscounts, discountTotal } = applyDiscounts(priceWithoutTaxes, discountRules, discountOrder);

        // Vergileri geri ekle (indirimlerden sonra)
        const { totalPrice: finalPriceWithTaxes, taxTotal: totalTaxesAdded } = addTaxes(priceAfterDiscounts, taxRules);

        // Toplamları güncelle
        totalDiscount += discountTotal;
        totalAdlPrice += totalPerPriceForDay;
        totalChlPrice += totalChlPriceForDay;

        // Ödeme miktarını hesapla
        let paymentAmountForDay = 0;
        let paymentAmountForDay2 = 0;
        let paymentAmountForDay3 = 0;

        const payrRule = discountRules.find(r => r.type === 'PAYR');
        if (payrRule) {
          paymentAmountForDay = priceAfterDiscounts * (payrRule.intVar / 100);
        }

        const payrRule2 = discountRules.find(r => r.type === 'PAYR2');
        if (payrRule2) {
          paymentAmountForDay2 = priceAfterDiscounts * (payrRule2.intVar / 100);
        }

        const payrRule3 = discountRules.find(r => r.type === 'PAYR3');
        if (payrRule3) {
          paymentAmountForDay3 = priceAfterDiscounts * (payrRule3.intVar / 100);
        }

        totalPaymentAmount += paymentAmountForDay;
        totalPaymentAmount2 += paymentAmountForDay2;
        totalPaymentAmount3 += paymentAmountForDay3;

        // Her bir gün için veri satırlarını ekle
        rows.push({
          date: formattedDate,
          period: contract.period,
          currency: currencies,
          per_price: perPrices,
          chl_price: chlPrices,
          total_price: finalPriceWithTaxes.toFixed(2),
          total_price_ndisc: totalPriceForDay.toFixed(2),
          payment_amount: paymentAmountForDay.toFixed(2),
          payment_amount2: paymentAmountForDay2.toFixed(2),
          payment_amount3: paymentAmountForDay3.toFixed(2),
          tax_removed: totalTaxesRemoved.toFixed(2),
          discount_applied: discountTotal.toFixed(2),
          tax_added: totalTaxesAdded.toFixed(2)
        });

        if (contract.get_per_price) {
          contract.get_per_price.forEach(price => {
            totalPerPrice += price.per_price;
          });
        }
      }
    }
  });
}


rows.push({
  date: "Total",
  period: "",
  currency: "EUR",
  per_price: totalPerPriceText,
  total_discount: totalDiscountText,
  total_price_with_discount: totalPriceWithDiscountText,
  payment_amount: totalPaymentAmountText,
  payment_amount2: totalPaymentAmountText2,
  payment_amount3: totalPaymentAmountText3,
  tax_removed: totalTaxRemovedText,
  tax_added: totalTaxAddedText,
  final_total_price_with_taxes: finalTotalPriceWithTaxes
});



const { loading: loadingPreAccFol, error: errorPreAccFol, data: dataPreAccFol, refetch: refetchPreAccFol } = useQuery(GET_REZ_ACC_PRE_FOL, {
  variables: { resMidId: resMidId , resRoomId: resRoomId, ownFirmCode: ownFirmCode, ownFirmSubCode : ownFirmSubCode},
});

const [updateBookingCount] = useMutation(UPDATE_BOOKING_COUNT);
const [updateBookingguat] = useMutation(UPDATE_BOOKING_GUAT);
const [updateBookingguat2] = useMutation(UPDATE_BOOKING_GUAR);

const handleUpdate2 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingCount({
        variables: {
          date: row.date,
          room_code: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};

const [updateBookingCountdown] = useMutation(UPDATE_BOOKING_COUNT_DOWN);

const handleUpdate3 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingCountdown({
        variables: {
          date: row.date,
          room_code: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};


const handleUpdate4 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingguat({
        variables: {
          date: row.date,
          room_type: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechavacont();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};


const handleUpdate6 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingguat2({
        variables: {
          date: row.date,
          room_type: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechavacont();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};

const [updateBookingguatdown] = useMutation(UPDATE_BOOKING_GUAT_DOWN);
const [updateBookingguatdown2] = useMutation(UPDATE_BOOKING_GUAR_DOWN);


const handleUpdate5 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingguatdown({
        variables: {
          date: row.date,
          room_type: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechavacont();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};

const handleUpdate7 = async () => {
  if (loadingPreAccFol) {
    alert('Data is loading, please wait');
    return;
  }

  if (errorPreAccFol) {
    console.error('Error fetching data:', errorPreAccFol);
    alert('Error fetching data');
    return;
  }

  if (!dataPreAccFol || !dataPreAccFol.tbl_rez_room_dtl) {
    console.error('No data found');
    alert('No data found');
    return;
  }

  try {
    for (const row of dataPreAccFol.tbl_rez_room_dtl) {
      console.log('Processing row:', row);
      const response = await updateBookingguatdown2({
        variables: {
          date: row.date,
          room_type: row.room_code,
          firm_main_code: row.firm_main_code,
          firm_sub_code: row.firm_sub_code
        }
      });
      console.log('Update response:', response);
    }

    alert('Booking count updated successfully');
    refechpreaccfol();
    refechavacont();
    refechava();
  } catch (error) {
    console.error('Error updating booking count:', error);
    alert('Error updating booking count');
  }
};






  useEffect(() => {
    
    refetch();  
   
    console.log('Sayfa açıldı!');
    
    // componentWillUnmount
    return () => {
      console.log('Sayfa kapatılıyor...');
      refetch();  
     
    };
  }, []);

  const [updateIdSeq3] = useMutation(UPDATE_ID_SEQ2);
  const [insertRezRoomDtl] = useMutation(INSERT_REZ_ROOM_DTL);
  const [insertRezRoomDllCalc] = useMutation(INSERT_REZ_ROOM_DLL_CALC);
  const [updatePrice] = useMutation(UPDATE_REZ_ROOM_DTL_PRICE);
  const [DeleteRezFolio] = useMutation(DELETE_REZ_FOLIO);
  const [DeleteRezFolioCalc] = useMutation(DELETE_REZ_FOLIO_CALC);
  const [DeleteRezRoom] = useMutation(DELETE_REZ_ROOM);
  const [DeleteRezGuest] = useMutation(DELETE_REZ_GUEST);

  

  const handleUpdateIdSeq3 = async () => {
    try {
      const { data } = await updateIdSeq3({
        variables: { type: 'MFIRM' }
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      return updatedIdSeq;
    } catch (error) {
      console.error('Güncelleme hatası:', error);
      throw error;
    }
  };

   // Function to handle the insertion
   const handleInsert = async () => {
    const rows = [];
    const discountRows = [];
    const taxRows = [];
  
    if (firmData4) {
      for (const contract of firmData4) {
        const contractStartDate = new Date(contract.start_date);
        const contractEndDate = new Date(contract.end_date);
  
        // Başlangıç ve bitiş tarihleri arasındaki günleri oluştur
        for (let date = new Date(arrivalDate); date <= departureDate; date.setDate(date.getDate() + 1)) {
          if (date < contractStartDate || date > contractEndDate) continue; // Sadece uygun tarihleri işleme al
  
          const formattedDate = new Date(date);
  
          const currencies = contract.get_per_price ? contract.get_per_price.map(price => price.currency).join(', ') : "N/A";
          const perPrices = contract.get_per_price ? contract.get_per_price.map(price => price.per_price).join(', ') : "N/A";
          const chlPrices = contract.get_per_price_chl ? contract.get_per_price_chl.map(price => price.per_price).join(', ') : "N/A";
  
          const totalPerPriceForDay = contract.get_per_price ? contract.get_per_price.reduce((total, price) => total + price.per_price, 0) : 0;
          const totalChlPriceForDay = contract.get_per_price_chl ? contract.get_per_price_chl.reduce((total, price) => total + price.per_price, 0) : 0;
  
          if (totalPerPriceForDay === 0 && totalChlPriceForDay === 0) {
            continue;
          }
  
          const idSeq = await handleUpdateIdSeq3();
  
          rows.push({
            firm_main_code: ownFirmCode,
            firm_sub_code: ownFirmSubCode,
            rez_top_id: resTopId,
            rez_mid_id: resMidId,
            rez_room_id: resRoomId,
            room_dtl_id: idSeq,
            date: formattedDate,
            room_code: resRoomType,
            product_code: 'ACC',
            type: 'ACC',
            quantity: 1,
            unit: 'NGT',
            price: totalPerPriceForDay + totalChlPriceForDay,
            price_base: totalPerPriceForDay + totalChlPriceForDay,
            currency: currencies,
            debit: 0,
            credit: totalPerPriceForDay + totalChlPriceForDay
          });
  
          // Discounts
          const discountRules = [];
  
          // GRPO indirimi
          const intVar1GRPO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_grp[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
          if (intVar1GRPO) {
            discountRules.push({ type: 'GRPO', intVar: intVar1GRPO });
          }
  
          // SSO indirimi
          const intVar1SSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_sen[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
          if (intVar1SSO) {
            discountRules.push({ type: 'SSO', intVar: intVar1SSO });
          }
  
          // EBO indirimi
          const intVar1EBO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_ebo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
          if (intVar1EBO) {
            discountRules.push({ type: 'EBO', intVar: intVar1EBO });
          }
  
          // HMO indirimi
          const intVar1HMO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_hmo[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
          if (intVar1HMO) {
            discountRules.push({ type: 'HMO', intVar: intVar1HMO });
          }
  
          // LSO indirimi
          const intVar1LSO = contract.get_cont_rule_id[0]?.get_cont_rule_sub_lst[0]?.get_cont_rule_grp[0]?.get_cont_rule_act[0]?.int_var_1 || 0;
          if (intVar1LSO) {
            discountRules.push({ type: 'LSO', intVar: intVar1LSO });
          }
  
          discountRules.forEach(discount => {
            discountRows.push({
              firm_main_code: ownFirmCode,
              firm_sub_code: ownFirmSubCode,
              rez_mid_id: resMidId,
              rez_room_id: resRoomId,
              rez_room_dtl_id: idSeq,
              code: discount.type,
              value: discount.intVar,
              red_sup: 'R',
              priority: 1,
              type: 'OFF'
            });
          });
  
          // Taxes
          contract.get_per_price.forEach(price => {
            if (price.get_room_tax) {
              price.get_room_tax.forEach(tax => {
                taxRows.push({
                  firm_main_code: ownFirmCode,
                  firm_sub_code: ownFirmSubCode,
                  rez_mid_id: resMidId,
                  rez_room_id: resRoomId,
                  rez_room_dtl_id: idSeq,
                  code: 'TAX',
                  value: tax.card_value,
                  red_sup: 'R',
                  priority: 1,
                  type: 'TAX',
                 
                });
              });
            }
          });
        }
      }
    }
  
    if (rows.length > 0) {
      try {
        await insertRezRoomDtl({ variables: { objects: rows } });
        console.log('Kayıtlar başarıyla eklendi.');
  
        if (discountRows.length > 0) {
          await insertRezRoomDllCalc({ variables: { objects: discountRows } });
          console.log('İndirim kayıtları başarıyla eklendi.');
        }
  
        if (taxRows.length > 0) {
          await insertRezRoomDllCalc({ variables: { objects: taxRows } });
          console.log('Vergi kayıtları başarıyla eklendi.');
          
          
        }
  
        refechpreaccfol();
        
        
      } catch (error) {
        console.error('Ekleme hatası:', error);
        console.error('Hata detayları:', JSON.stringify(error, null, 2));
      }
    }
  };
 
  

  const handleUpdatePrices = async () => {
    if (datapreaccfol && datapreaccfol.tbl_rez_room_dtl) {
      for (const record of datapreaccfol.tbl_rez_room_dtl) {
        if (!record.room_dtl_id) {
          console.error('room_dtl_id eksik:', record);
          continue; // room_dtl_id eksikse bu kaydı atla
        }

        let updatedPrice = record.price_base || record.price; // Başlangıç fiyatı
        let recordTaxes = 0;
        let recordDiscounts = 0;
        let recordAdditionalTaxes = 0;

      // Apply TAX discounts first
      record.get_room_folio_price_calc
        .filter(discount => discount.type === 'TAX')
        .forEach(discount => {
          const discountAmount = updatedPrice * (discount.value  / (100 + discount.value));
          
          updatedPrice -= discountAmount;
          recordTaxes += discountAmount;
        });

      // Apply other discounts
      record.get_room_folio_price_calc
        .filter(discount => discount.type !== 'TAX')
        .forEach(discount => {
          const discountAmount = updatedPrice * (discount.value / 100);
          updatedPrice -= discountAmount;
          recordDiscounts += discountAmount;
        });

      // Calculate additional taxes on discounted price
      record.get_room_folio_price_calc
        .filter(discount => discount.type === 'TAX') // Assuming 'ADDITIONAL_TAX' is used for additional tax type
        .forEach(discount => {
          const additionalTaxAmount = updatedPrice * (discount.value / 100);
          updatedPrice += additionalTaxAmount; // Add the tax back to the updated price
          recordAdditionalTaxes += additionalTaxAmount;
        });

        // Fiyatı güncelle
        try {
          const response = await updatePrice({
            variables: {
              id: record.room_dtl_id,
              price: updatedPrice.toFixed(2),
              credit: updatedPrice.toFixed(2) * record.quantity,
              ownFirmCode: record.firm_main_code,
              ownFirmSubCode: record.firm_sub_code,
              rezTopId: resTopId,
              rezMidId: resMidId,
              rezRoomId: resRoomId
            }
          });
          console.log(`Kayıt güncellendi: ${record.room_dtl_id} yeni fiyat: ${updatedPrice}`, response);
          
        } catch (error) {
          console.error(`Güncelleme hatası (ID: ${record.room_dtl_id}):`, error);
          if (error.networkError) {
            console.error('Network Error:', error.networkError);
          }
          if (error.graphQLErrors) {
            error.graphQLErrors.forEach(err => console.error('GraphQL Error:', err));
          }
        }
      }

      // Verileri yeniden sorgula
      refechpreaccfol();
      handleUpdateprice();
    }
  };

  const [totals, setTotals] = useState({ basePrice: 0, discounts: 0, taxes: 0, additionalTaxes: 0, finalPrice: 0 });

useEffect(() => {
  if (datapreaccfol && datapreaccfol.tbl_rez_room_dtl) {
    let basePrice = 0;
    let discounts = 0;
    let taxes = 0;
    let additionalTaxes = 0;
    let finalPrice = 0;

    datapreaccfol.tbl_rez_room_dtl.forEach(record => {
      let updatedPrice = record.price_base || record.price;
      let recordTaxes = 0;
      let recordDiscounts = 0;
      let recordAdditionalTaxes = 0;

      // Apply TAX discounts first
      record.get_room_folio_price_calc
        .filter(discount => discount.type === 'TAX')
        .forEach(discount => {
          const discountAmount = updatedPrice * (discount.value  / (100 + discount.value));
          
          updatedPrice -= discountAmount;
          recordTaxes += discountAmount;
        });

      // Apply other discounts
      record.get_room_folio_price_calc
        .filter(discount => discount.type !== 'TAX')
        .forEach(discount => {
          const discountAmount = updatedPrice * (discount.value / 100);
          updatedPrice -= discountAmount;
          recordDiscounts += discountAmount;
        });

      // Calculate additional taxes on discounted price
      record.get_room_folio_price_calc
        .filter(discount => discount.type === 'TAX') // Assuming 'ADDITIONAL_TAX' is used for additional tax type
        .forEach(discount => {
          const additionalTaxAmount = updatedPrice * (discount.value / 100);
          updatedPrice += additionalTaxAmount; // Add the tax back to the updated price
          recordAdditionalTaxes += additionalTaxAmount;
        });

      basePrice += record.price_base || record.price;
      discounts += recordDiscounts;
      taxes += recordTaxes;
      additionalTaxes += recordAdditionalTaxes;
      finalPrice += updatedPrice;
    });

    setTotals({ basePrice, discounts, taxes, additionalTaxes, finalPrice });
  }
}, [datapreaccfol]);
 





  useEffect(() => {
    
    if (firmTrg !== '') {
      // newId güncellendiğinde
    handleinser();  
    
    }
  }, [firmTrg, setFirmTrg]);


 

  useEffect(() => {
    if (firmData) {




        setResTopId(varCode7);
        setResMidId(varCode4);
        setResRoomId(firmData.rez_room_id);
        setResFolioId(firmData.folio_id);
        setResRoomClass(firmData.room_class);
        setResRoomType(firmData.room_type);
        setStartDate(new Date(firmData.arrival_date));
          setEndDate(new Date(firmData.departure_date));
          setPerAdl(firmData.person_adl);
          setPerChl(firmData.person_chl);
          setGuaUse(firmData.guar_use);

     
      
    }
  }, [firmData]);

  
  const handleUpdateprice = () => {
   
    
    updateRulesPrn({
      variables: {
      

        resMidId: resMidId,
        resRoomId: resRoomId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        resFolioId: resFolioId,
        resRoomClass: resRoomClass,
        resRoomType: resRoomType,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        perAdl: perAdl,
        perChl: perChl,
        totalPerPriceText: totals.finalPrice.toFixed(2),
        guaUse: guaUse,
     

        
      },
    })
      .then(() => {
        window.alert(" updated successfully!");
        refetch();
       
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  

  const handleUpdate = () => {
   
    
    updateRulesPrn({
      variables: {
      

        resMidId: resMidId,
        resRoomId: resRoomId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        resFolioId: resFolioId,
        resRoomClass: resRoomClass,
        resRoomType: resRoomType,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        perAdl: perAdl,
        perChl: perChl,
        totalPerPriceText: totals.finalPrice.toFixed(2),
        guaUse: guaUse,
     

        
      },
    })
      .then(() => {
        window.alert(" updated successfully!");
        refetch();
        handleUpdate3();
        handleUpdate5();
        if (guaUse) {
          handleUpdate7();
        }
        handleRezFolioDelete();
        handleRezFolioCalcDelete();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['resRoomType', 'resRoomClass' ]; // Required fiels
    const customFieldNames = {
      resRoomType: "Room Type",
     
      resRoomClass: "Room Class",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
       
        
        setFirmTrg(String(updatedIdSeq));
        setRulPernId(String(updatedIdSeq));
        setVarCode(String(updatedIdSeq));
        setResRoomId(updatedIdSeq);
        setResFolioId(updatedIdSeq);
        
        setResMidId(varCode4);
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(rulPernId);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {

        
        resTopId: varCode7,
        resMidId: varCode4,
        resRoomId: resRoomId,
        resFolioId: resFolioId,
        ownFirmCode: ownFirmCode,
        ownFirmSubCode: ownFirmSubCode,
        resFolioId: resRoomId,
        resRoomClass: resRoomClass,
        resRoomType: resRoomType,
        startDate: new Date(startDate).toLocaleDateString(),
        endDate: new Date(endDate).toLocaleDateString(),
        perAdl: perAdl,
        perChl: perChl,
        guaUse: guaUse,

    
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
   // setVarCode9(ruleType)
   
    setDisplayBasic2(true);
   
    
  };

  const handleRezRoomDelete = () => {
    DeleteRezRoom({
      variables: {
         
        firmMainCode: ownFirmCode,
        firmSubCode: ownFirmSubCode,
        resMidId: resMidId,
        resRoomId: resRoomId,
          
      },
    })
      .then(() => {
        window.alert("Room Deleted successfully!");
        handleUpdate3();
        handleUpdate5();
        if (guaUse) {
          handleUpdate7();
        }
        handleRezFolioDelete();
        handleRezFolioCalcDelete();
        handleRezGuestDelete();
       
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };

  const handleRezFolioDelete = () => {
    DeleteRezFolio({
      variables: {
         
        firmMainCode: ownFirmCode,
        firmSubCode: ownFirmSubCode,
        resMidId: resMidId,
        resRoomId: resRoomId,
          
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
       
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };

  const handleRezFolioCalcDelete = () => {
    DeleteRezFolioCalc({
      variables: {
         
        firmMainCode: ownFirmCode,
        firmSubCode: ownFirmSubCode,
        resMidId: resMidId,
        resRoomId: resRoomId
          
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
        refechpreaccfol();
       
      
      })
      .catch((error) => {
        console.error("Error Deleted Calc:", error);
      });
  };

  const handleRezGuestDelete = () => {
    DeleteRezGuest({
      variables: {
         
        firmMainCode: ownFirmCode,
        firmSubCode: ownFirmSubCode,
        resMidId: resMidId,
        resRoomId: resRoomId,
          
      },
    })
      .then(() => {
        window.alert("Contract Per Deleted successfully!");
       
      
      })
      .catch((error) => {
        console.error("Error Deleted Cont Per Price:", error);
      });
  };

  const onClick2 = () => {
    setVarCode8(resRoomId);   
    setVarCode14(0);  
   // setVarCode9(ruleType)
    setDisplayBasic2(true);
    
  };
  
  const onHide2 = () => {
    setDisplayBasic2(false);
    refetch();
    refechgue();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.active
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.active ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const roomClasstems = defData && defData.tbl_htl_room_class
  ? defData.tbl_htl_room_class.map(item => ({
      label: item.r_class_name,
      value: item.r_class_code,
      name: item.r_class_name, 
    }))
  : [];

  const rulesTypeItems = defData2 && defData2.tbl_htl_room_type
  ? defData2.tbl_htl_room_type.map(item => ({
      label: item.r_type_name,
      value: item.r_type_code,
      name: item.r_type_name, 
    }))
  : [];






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room Detail"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>

    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">

                


      <div className="flex gap-4">
    
          <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Mid Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resMidId}
    onChange={(e) => setResMidId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Room Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resRoomId}
    onChange={(e) => setResRoomId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Folio Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resFolioId}
    onChange={(e) => setResFolioId(e.target.value)}
    readOnly
    />
  </div>


  

  <div className="w-2/8 h-10 gap-3">
        <label                
         htmlFor="firmname"> {"Arrival"}</label>
        <Calendar className="w-full h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={startDate} dateFormat="dd/mm/yy"
        onChange={(e) => setStartDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
      

      <div className="w-2/8 gap-3">
        <label                
         htmlFor="firmname"> {"Departure"}</label>
        <Calendar className="w-1/8 h-11" 
        inputStyle={{ showIcon: 'text-gray-900', width:'80%'  }}
        style={{ width:"%80" }}    
        id="firmname" value={endDate} dateFormat="dd/mm/yy"
        onChange={(e) => setEndDate(e.target.value)} 
        showIcon
        locale="tr"/>
      </div>
   


  <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
  </div> 

  </div>

  <div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Aduld"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perAdl}
    onChange={(e) => setPerAdl(e.target.value)}
    
    />
  </div>

  <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Child"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perChl}
    onChange={(e) => setPerChl(e.target.value)}
  
    />
  </div>


  <div className="w-2/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Class"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resRoomClass} 
    onChange={(e) => setResRoomClass(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Class Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomClass}
         options={roomClasstems}
         onChange={(e) => setResRoomClass(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>

       <div className="w-2/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Type"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resRoomType} 
    onChange={(e) => setResRoomType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomType}
         options={rulesTypeItems}
         onChange={(e) => setResRoomType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>
   


  <div className="mr-2 w-1/5">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Guarany"}
    </label>
    <InputSwitch checked={guaUse} onChange={(e) => setGuaUse(e.value)} />
  </div> 

  </div>

      <div className="flex mt-5 mb-0 gap-4 ">
      <div className="w-2/4">
     
  </div>
  <Divider align="right">
                <div className="inline-flex align-items-center">
                   
                    <b>{finalTotalPriceWithTaxes +" "+"EUR"}</b>
                </div>
            </Divider>
  
  <div className="w-2/4">
    <Button
      label={"Remove Room"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleRezRoomDelete}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={"New Room"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>


</p>
   </Fieldset>
       </div>
 
       </div>          
  
  </div>



  <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabS} onTabChange={(e) => handleTabChangeS(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Hotel Room Status"}
            </span>
          }
          className="ml-5 flex"
        >
    
  

 <p> <DataTable
         value={firmData2 }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="room_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Id"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column
           field="start_date"
           header={<span className="font-bold text-sm text-gray-900">{"Arrival Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />
        

          <Column field="capacity"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Capacity"}</span>}
           style={{ textAlign: 'center', width: '5rem' }}
          >
          </Column>
          <Column field="close"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Close"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="booking"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Reservation'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>


          <Column field="guaranty"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Guaranty'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="pseudo"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Pseudo'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="waiting"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Option'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          
<Column
  field="capacityMinusWaiting"
  header={<span className="font-bold text-gray-900">{'Avaibility'}</span>}
  style={{ textAlign: 'left', width: '5rem' }}
  body={(rowData) => {
    // rowData'dan gerekli verileri alarak hesaplama yap
    const capacity = rowData.capacity || 0; // Eğer capacity null veya undefined ise varsayılan değer olarak 0 kullan
    const waiting = rowData.waiting || 0; // Eğer waiting null veya undefined ise varsayılan değer olarak 0 kullan
    const close = rowData.close || 0; 
    const booking = rowData.booking || 0;
    const guaranty = rowData.guaranty || 0;
    
    // capacity - waiting - close hesaplama
    const capacityMinusWaiting = capacity - booking - close - guaranty;
    
    // Sonucu döndür
    return (
      <div className="text-xs font-extrabold text-right">{capacityMinusWaiting}</div>
    );
  }}
/>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{'Stop Sale'}</span>}
            style={{ textAlign: 'center', width: '30rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                                  
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

        </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Contract Room Status"}
            </span>
          }
          className="ml-5 flex"
        >


      
       
       
       
      
       

<p> <DataTable
         value={firmData3 }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="room_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Id"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column
           field="date"
           header={<span className="font-bold text-sm text-gray-900">{"Arrival Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />
        

          <Column field="room_total_contg"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Total Cuota"}</span>}
           style={{ textAlign: 'center', width: '5rem' }}
          >
          </Column>
          <Column field="room_contg_use"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Use Cuota"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="room_total_gua"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Guaranty'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>


          <Column field="room_gua_use"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Use Guaranty'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="pseudo"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Pseudo'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="change_contg"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Option'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          
<Column
  field="capacityMinusWaiting"
  header={<span className="font-bold text-gray-900">{'Avaibility'}</span>}
  style={{ textAlign: 'left', width: '5rem' }}
  body={(rowData) => {
    // rowData'dan gerekli verileri alarak hesaplama yap
    const totcontg = rowData.room_total_contg || 0; // Eğer capacity null veya undefined ise varsayılan değer olarak 0 kullan
    const contguse = rowData.room_contg_use || 0; // Eğer waiting null veya undefined ise varsayılan değer olarak 0 kullan
    const close = rowData.close || 0; 
    const booking = rowData.booking || 0;
    const guaranty = rowData.guaranty || 0;
    
    // capacity - waiting - close hesaplama
    const capacityMinusWaiting = totcontg - contguse - close - guaranty;
    
    // Sonucu döndür
    return (
      <div className="text-xs font-extrabold text-right">{capacityMinusWaiting}</div>
    );
  }}
/>

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{'Stop Sale'}</span>}
            style={{ textAlign: 'center', width: '30rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
                           
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

         
    

              </TabPanel>
            
          </TabView>   
     
    

        

              </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room Price"}
            </span>
          }
          className="ml-5 flex"
        >

          


<div>
      {varCode3 === "AGN" && (
        <>
          <DataTable
            value={rows}
            scrollable 
            scrollHeight="250px"
            loading={loading}
            stickyHeader
            stickyTopAt=".layout-topbar"
          >
            <Column
              field="date"
              header={<span className="font-bold text-sm text-gray-900">{"Date"}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="period"
              header={<span className="font-bold text-sm text-gray-900">{"Period"}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="per_price"
              header={<span className="font-bold text-sm text-gray-900">{"Aduld"}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="chl_price"
              header={<span className="font-bold text-sm text-gray-900">{"Childs"}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="total_price_ndisc"
              header={<span className="font-bold text-sm text-gray-900">{"Total:" + totalPerPriceText}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="total_price"
              header={<span className="font-bold text-sm text-gray-900">{"Total:" + totalPerPriceText}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="currency"
              header={<span className="font-bold text-sm text-gray-900">{"Currency"}</span>}
              style={{ textAlign: 'left', width: '10rem' }}
            />
            <Column
              field="active"
              body={getStatusLabel}
              header={<span className="font-bold text-right text-gray-900">{totalPerPriceText}</span>}
              style={{ textAlign: 'center', width: '10rem' }}
              className="font-bold text-sm"
            />
            <Column
              header={<span className="font-bold text-sm text-gray-900">{"Detail"}</span>}
              body={(rowData) => (
                <button
                  onClick={() => onClick()}
                  className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
                >
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                    <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
                  </svg>
                </button>
              )}
              style={{ textAlign: 'center', width: '6rem' }}
            />
          </DataTable>
          
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Sub Total: ${totalPerPriceText}`}
          </label>
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Offers Total: ${totalDiscountText}`}
          </label>
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Total Price: ${totalPriceWithDiscountText}`}
          </label>
          <label className="block font-medium text-gray-950">
            {`Payment Amount: ${totalPaymentAmountText}`}
          </label>
          <label className="block font-medium text-gray-950">
            {`Payment Amount2: ${totalPaymentAmountText2}`}
          </label>
          <label className="block font-medium text-gray-950">
            {`Payment Amount3: ${totalPaymentAmountText3}`}
          </label>
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Total Price: ${finalTotalPriceWithTaxes}`}
          </label>
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Total Price: ${totalTaxRemovedText}`}
          </label>
          <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4" htmlFor="firmname">
            {`Total Price: ${totalTaxAddedText}`}
          </label>
        </>
      )}

{(varCode3 === "CUS" || varCode3 === "OTS") && (
       
        <div>
    <DataTable
  value={firmData41}
  scrollable 
  scrollHeight="250px"
  loading={loodingprc}
  stickyHeader
  stickyTopAt=".layout-topbar"
>
  <Column
    field="price_date"
    header={<span className="font-bold text-sm text-gray-900">{"Date"}</span>}
    style={{ textAlign: 'left', width: '10rem' }}
  />
  <Column
    field="per_price"
    header={<span className="font-bold text-sm text-gray-900">{"Adult Price"}</span>}
    style={{ textAlign: 'left', width: '10rem' }}
  />
  <Column
    field="get_child_daily_price"
    header={<span className="font-bold text-sm text-gray-900">{"Child Price"}</span>}
    body={(rowData) => (
      rowData.get_child_daily_price.length > 0 
      ? rowData.get_child_daily_price.map((child, index) => child.per_price).join(", ")
      : <span>No Child Price</span>
    )}
    style={{ textAlign: 'left', width: '10rem' }}
  />
  <Column
    field="total_price"
    header={<span className="font-bold text-sm text-gray-900">{"Total Price"}</span>}
    body={(rowData) => {
      const childTotal = rowData.get_child_daily_price.reduce((sum, child) => sum + child.per_price, 0);
      const totalPrice = rowData.per_price + childTotal;
      return <span>{totalPrice}</span>;
    }}
    style={{ textAlign: 'left', width: '10rem' }}
  />
</DataTable>
    <div className="font-bold text-sm text-gray-900">
      {"Total Adult Price: " + totalAdultPrice}
    </div>
    <div className="font-bold text-sm text-gray-900">
      {"Total Child Price: " + totalChildPrice}
    </div>
    <div className="font-bold text-sm text-gray-900">
      {"Total Price: " + totalPrice}
    </div>
  </div>

)}

</div>

     



              </TabPanel>



              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room Guest"}
            </span>
          }
          className="ml-5 flex"
        >
<div>
<Dialog visible={displayBasic2}  style={{ width: '75vw' }} header={"Accomodation Plan"} onHide={onHide2}>
  <p>
   {<HtlResRoomGuestEdit/>}
  </p>
</Dialog>
</div>
          

<div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Aduld"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perAdl}
    onChange={(e) => setPerAdl(e.target.value)}
    
    />
  </div>

  <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Child"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perChl}
    onChange={(e) => setPerChl(e.target.value)}
  
    />
  </div>


  <div className="w-2/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Type"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resRoomType} 
    onChange={(e) => setResRoomType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomType}
         options={rulesTypeItems}
         onChange={(e) => setResRoomType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>

   


  <div className="mr-2 w-1/5">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
    
  </div> 

  <div className="w-2/4">
    <Button
      label={"New Room"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>

  <div className="w-2/4">
    <Button
      label={"New Room"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>

  </div>

      <div className="flex mt-5 mb-0 gap-4 ">
      <div className="w-2/4">
     
  </div>
  <Divider align="right">
                <div className="inline-flex align-items-center">
                   
                    <b>{finalTotalPriceWithTaxes +" "+"EUR"}</b>
                </div>
            </Divider>
  
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={"New Guest"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={onClick2}
    />
  </div>
</div>


<p> <DataTable
         value={firmData5 }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="rez_top_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Top Id"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

         
        

          <Column field="rez_mid_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Mid Id"}</span>}
           style={{ textAlign: 'center', width: '5rem' }}
          >
          </Column>
          <Column field="rez_room_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Room"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="guest_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Guest'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>


          <Column field="profile_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Profile'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="title"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Title'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Name'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="last_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Last Name'}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

          <Column field="country"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Country'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="guest_type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Type'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

 

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{'Offers'}</span>}
            style={{ textAlign: 'center', width: '5rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
               setVarCode14(rowData.guest_id);  
           //     setVarCode(rowData.dpr_main_code);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    






              </TabPanel>

              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Accomodation Folio"}
            </span>
          }
          className="ml-5 flex"
        >
<div>
<Dialog visible={displayBasic2}  style={{ width: '75vw' }} header={"Accomodation Folio Detail 1"} onHide={onHide2}>
  <p>
   {<HtlResRoomFolioDtl/>}
  </p>
</Dialog>
</div>
          

<div className="flex gap-4">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Aduld"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perAdl}
    onChange={(e) => setPerAdl(e.target.value)}
    
    />
  </div>

  <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Child"}</label>
    <InputText className="w-full text-base" 
    id="username" value={perChl}
    onChange={(e) => setPerChl(e.target.value)}
  
    />
  </div>


  <div className="w-20 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Type"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={resRoomType} 
    onChange={(e) => setResRoomType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
        style={{ width: '244px' }} 
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomType}
         options={rulesTypeItems}
         onChange={(e) => setResRoomType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>

   


  <div className="mr-2 w-1/5">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
    
  </div> 


  </div>

      <div className="flex mt-5 mb-0 gap-4 ">
      <div className="w-2/4">
     
  </div>
  <Divider align="right">
                <div className="inline-flex align-items-center">
                   
                    <b>{finalTotalPriceWithTaxes +" "+"EUR"}</b>
                </div>
            </Divider>
  

  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  
      {varCode3 === "AGN" && (
        <div className="w-2/4">
          <Button
            label={"Get C Folio"}
            aria-label="Update"
            className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
            onClick={handleInsert}
          />
        </div>
      )}

      {varCode3 === "CUS" && (
        <div className="w-2/4">
          <Button
            label={"Get P Folio"}
            aria-label="Update"
            className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
            onClick={handleInsert2}
          />
        </div>
      )}
    </div>



<p> <DataTable
         value={firmData6 }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="rez_top_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Top Id"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

         
        

          <Column field="rez_mid_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Mid Id"}</span>}
           style={{ textAlign: 'center', width: '5rem' }}
          >
          </Column>
          <Column field="rez_room_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Room"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column
           field="date"
           header={<span className="font-bold text-sm text-gray-900">{"Arrival Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

          <Column field="room_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Guest'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>


          <Column field="product_code"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Profile'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="type"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Title'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="quantity"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Name'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="unit"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Last Name'}</span>}
           style={{ textAlign: 'left', width: '7rem' }}
          >
          </Column>

          <Column field="price"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Country'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="currency"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Type'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>
          <Column field="debit"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Type'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="credit"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{'Type'}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

 

          <Column
            field="active"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{'Offers'}</span>}
            style={{ textAlign: 'center', width: '5rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
               setVarCode9(rowData.room_dtl_id);  
           //     setVarCode(rowData.dpr_main_code);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

        <div>
      <button onClick={handleInsert}>Add Contract Folio</button>
    </div>
    <div>
      <button onClick={handleInsert2}>Add Price Folio</button>
    </div>
    <div>
      <button onClick={handleUpdatePrices}>Fiyatları Güncelle</button>

      <button onClick={handleUpdate2}>kontajan Güncelle</button>

      <button onClick={handleUpdate4}>kontajan Q Güncelle</button>

      <button onClick={handleUpdate6}>kontajan G Güncelle</button>
      
      
      {/* Verilerinizi burada görüntüleyebilirsiniz */}
    </div>

    <div>
        <h3>Toplamlar</h3>
        <p>Base Price Toplamı: {totals.basePrice.toFixed(2)}</p>
        <p>İndirim Toplamı: {totals.discounts.toFixed(2)}</p>
        <p>Vergi Toplamı: {totals.taxes.toFixed(2)}</p>
        <p>Vergi Toplamı: {totals.additionalTaxes.toFixed(2)}</p>
        <p>Genel Toplam: {totals.finalPrice.toFixed(2)}</p>
      </div>






              </TabPanel>
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlResRoomAdd;

/*

  
<DataTable
value={rows}
scrollable 
scrollHeight="250px"
loading={loading}
stickyHeader
stickyTopAt=".layout-topbar"
>
<Column
  field="date"
  header={<span className="font-bold text-sm text-gray-900">{"Date"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>
<Column
  field="period"
  header={<span className="font-bold text-sm text-gray-900">{"Period"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>

<Column
  field="per_price"
  header={<span className="font-bold text-sm text-gray-900">{"Period"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>
<Column
  field="currency"
  header={<span className="font-bold text-sm text-gray-900">{"currency"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>

</DataTable>
*/
